<template>
  <div class="relative pb-48">
    <!-- {{ selectedLocation }} -->

    <van-popup v-model="toggleType" round position="bottom">
      <van-picker
        title="Status"
        confirm-button-text="Pilih"
        cancel-button-text="Batal"
        show-toolbar
        :columns="selectionType"
        @cancel="toggleType = false"
        @confirm="
          (e) => {
            selectedType = e;
            toggleType = false;
          }
        "
      />
    </van-popup>
    <hr class="mt-4 border-b bg-primary opacity-50 mx-4" />

    <van-cell-group title="Pilih Inventori" inset>
      <van-cell
        :title="`Jenis Inventori`"
        description="Pilih Jenis Inventori"
        is-link
        @click="() => (toggleType = true)"
      >
        <template #icon>
          <v-icon icon="ph:clipboard-text" class="text-2xl my-auto ml-2 mr-4 text-primary" />
        </template>
      </van-cell>

      <template v-if="selectedType">
        <van-cell :title="`Sisa ${selectedType}`" :label="`Tersisa ${amount} pcs`" class="animate-flashing">
          <template #icon>
            <v-icon icon="ph:check-circle" class="text-2xl my-auto ml-2 mr-4 text-success" />
          </template>
        </van-cell>
      </template>
    </van-cell-group>

    <van-cell-group title="Pengurangan Inventori" v-if="selectedType" inset>
      <van-field
        v-model="subtractionAmount"
        type="number"
        label="Penggunaan (Pcs)"
        placeholder="Masukkan jumlah pengurangan"
        :min="0"
        :max="1000000"
      >
        <template #icon>
          <v-icon icon="ph:minus-circle" class="text-2xl my-auto ml-2 mr-4 text-danger" />
        </template>
      </van-field>
    </van-cell-group>

    <van-cell-group title="Kalkulasi" v-if="selectedType" inset>
      <van-cell :title="`Sisa ${selectedType}`" :label="`Tersisa ${amount} pcs`">
        <template #icon>
          <v-icon icon="ph:calculator" class="text-2xl my-auto ml-2 mr-4 text-primary" />
        </template>
      </van-cell>
      <van-cell :title="`Pengurangan ${selectedType}`" :label="`${subtractionAmount} pcs`">
        <template #icon>
          <v-icon icon="ph:minus-circle" class="text-2xl my-auto ml-2 mr-4 text-danger" />
        </template>
      </van-cell>
      <van-cell :title="`Total ${selectedType}`" :label="`${amount - subtractionAmount} pcs`">
        <template #icon>
          <v-icon icon="ph:check-circle" class="text-2xl my-auto ml-2 mr-4 text-success" />
        </template>
      </van-cell>
    </van-cell-group>

    <div class="fixed max-w-xl w-full bottom-0 bg-white px-2 py-4 flex items-end shadow-md shadow-primary">
      <div class="w-full pr-2">
        <p v-if="!allDone" class="text-sm text-danger">*Harap isi semua untuk mengirim</p>
      </div>

      <van-button
        :disabled="!allDone"
        :loading="isLoading"
        type="info"
        loading-type="spinner"
        class="whitespace-nowrap bg-primary border-none"
      >
        <v-icon icon="material-symbols:send" class="text-2xl mr-1 inline" />
        <span class="ml-2 font-bold">Simpan</span>
      </van-button>
    </div>
  </div>
</template>

<style scoped>
  .animate-flashing {
    animation: flashing 1s infinite;
  }

  @keyframes flashing {
    0% {
      --tw-bg-opacity: 1;
    }
    50% {
      --tw-bg-opacity: 0.1;
    }
    100% {
      --tw-bg-opacity: 1;
    }
  }
</style>

<script>
  import { location } from "@/states/location";
  import dayjs from "dayjs";
  import { users } from "@/states/user";
  // import { queueManager } from "@/states/local";

  import local from "@/states/local";
  // import { deleteUpload } from "@/plugins/axios";
  // import instance from "@/plugins/axios";

  export default {
    components: {
      // PictureForm,
    },

    data() {
      return {
        isLoading: false,
        toggleType: false,
        selectedType: null,
        selectionType: ["Tissue", "Sabun", "Shampoo"],
        selectedLocation: null,
        amount: 69420,
        subtractionAmount: 0,
        tracking: location,
        local,
        users
      };
    },
    props: {
      isIn: {
        type: Boolean,
        default: true
      }
    },

    mounted() {},

    computed: {
      allDone() {
        return this.lokasi && this.foto.isPassLimit;
      }
    },

    methods: {
      hasBypass() {
        return this.users.data?.occupationPermission?.includes("explicitNoLocation");
      },
      formatTime(time, format = "HH:mm") {
        return dayjs(time).format(format);
      }
    }
  };
</script>
